import React from 'react';
import Invoices from '../components/Invoices';

function InvoicesPage() {
  return (
    <Invoices/>
  );
}

export default InvoicesPage;
